export default __webpack_public_path__ + "static/media/verified.fc3f7fca.png";